import { TranslationMessageTree } from "./translation"
import { TranslationMessages } from "./translation-messages.generated"

type LeafPaths<Tree> = {
  [Segment in keyof Tree & string]: Tree[Segment] extends string
    ? Segment
    : `${Segment}.${LeafPaths<Tree[Segment]>}`
}[keyof Tree & string]

// Every dot-separated key with a message, e.g. "common.jobStatus.booked".
// Shared code returns these instead of Swedish text and the caller translates.
export type TranslationKey = LeafPaths<TranslationMessages>

export type TranslationArguments = Record<string, string | number>

// The shape of a root `useTranslations()` from use-intl/next-intl, and of the
// API's TranslationService translator, so helpers in @repo/common can build
// sentences without knowing which runtime they run in.
export type Translator = (
  key: TranslationKey,
  values?: TranslationArguments,
) => string

// True when `value` is a key that has a message in `messages`. Used to render
// strings that may be either a key (zod messages) or already-final text.
export const isTranslationKey = (
  messages: TranslationMessageTree,
  value: string,
): value is TranslationKey => {
  let node: string | TranslationMessageTree | undefined = messages
  for (const segment of value.split(".")) {
    if (node === undefined || typeof node === "string") return false
    node = node[segment]
  }
  return typeof node === "string"
}
